// extracted by mini-css-extract-plugin
export default {"box":"Common_box__B8i4y","top":"Common_top__0gzAf"};